var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.92892L6.17158 4.75735L7.58579 6.17156L10.4142 3.34313C11.5809 2.17641 13.4901 2.17641 14.6569 3.34313C15.8236 4.50986 15.8236 6.41905 14.6569 7.58578L11.8284 10.4142L13.2426 11.8284L16.0711 8.99999C18.0227 7.04837 18.0227 3.88054 16.0711 1.92892C14.1195 -0.0226938 10.9516 -0.0226939 9 1.92892ZM10.4142 11.8284L7.58579 14.6568C6.41906 15.8236 4.50988 15.8236 3.34315 14.6568C2.17642 13.4901 2.17642 11.5809 3.34315 10.4142L6.17158 7.58578L4.75736 6.17156L1.92894 8.99999C-0.0226787 10.9516 -0.0226787 14.1194 1.92894 16.0711C3.88055 18.0227 7.04839 18.0227 9 16.0711L11.8284 13.2426L10.4142 11.8284ZM5.46447 11.1213L11.1213 5.46445L12.5355 6.87867L6.87868 12.5355L5.46447 11.1213Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.b2a61e8784ab37be3a0f34b03df84b4c.svg";
export { ForwardRef as ReactComponent };